module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.programmes != null && (!_vm.individual_days || (_vm.individual_days && _vm.programmes.length > 1)) && !_vm.isQuickAdd) ? _c('div', [_c('div', {
    staticClass: "switch-box-fixed"
  }, [_c('div', {
    staticClass: "switch-package-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show_switch_option == 'weeks') ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(this.$root.locale.booking.packages.text_switch_to_full_weeks)
    },
    on: {
      "click": _vm.switcher
    }
  }) : (_vm.show_switch_option == 'days') ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(this.$root.locale.booking.packages.text_switch_to_individual_days)
    },
    on: {
      "click": _vm.switcher
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _vm._l((_vm.programmes), function(programme) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
    }, [_c('div', {
      staticClass: "box-layout-inner select-a-package"
    }, [(programme.package_state_id == 4 || (!programme.isAvailable && (programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18))) ? _c('div', {
      staticClass: "ribbon-wrapper"
    }, [_c('div', {
      staticClass: "ribbon",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.ribbon_sold_out)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "block-inner-image",
      style: ({
        background: 'url(' + programme.image_url + ') center center / cover no-repeat'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "title-block-alt"
    }, [_c('div', {
      staticClass: "alt-container"
    }, [_c('span', [_vm._v(_vm._s(programme.name))]), _vm._v(" "), _c('b', {
      staticClass: "price"
    }, [_vm._v("£" + _vm._s(programme.price) + " / " + _vm._s(programme.price_per))])])]), _vm._v(" "), _c('div', {
      staticClass: "content-block"
    }, [_c('transition-group', {
      attrs: {
        "name": "list"
      }
    }, [_c('div', {
      key: 0,
      staticClass: "hidden-sm hidden-md hidden-lg"
    }, [(_vm.descriptions.indexOf(programme.id) > -1) ? _c('span', {
      staticClass: "full-description",
      domProps: {
        "innerHTML": _vm._s(programme.full_description)
      }
    }) : _c('span', {
      staticClass: "short-description"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(programme.short_description)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "cta-button blue",
      on: {
        "click": function($event) {
          _vm.readMore(programme.id)
        }
      }
    }, [_vm._v("Read more")])])]), _vm._v(" "), _c('div', {
      key: 1,
      staticClass: "hidden-xs"
    }, [_c('span', {
      staticClass: "full-description",
      domProps: {
        "innerHTML": _vm._s(programme.full_description)
      }
    })])])], 1), _vm._v(" "), (!_vm.individual_days) ? _c('div', {
      staticClass: "full-width-cta"
    }, [(programme.package_state_id == 2 && ((programme.prog_id != 1 && programme.prog_id != 17 && programme.prog_id != 18) || ((programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18) && Object.values(programme.availability).every(function (num) { return num > 0; })))) ? _c('a', {
      staticClass: "cta-button red",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_on_sale)
      },
      on: {
        "click": function($event) {
          _vm.progress(this, programme)
        }
      }
    }) : (programme.prog_id == 1 && (programme.package_state_id == 4 || (Object.values(programme.availability).some(function (num) { return num <= 0; })))) ? _c('a', {
      staticClass: "cta-button blue",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_click_to_subscribe_multi_acitve)
      }
    }) : ((programme.prog_id == 17 || programme.prog_id == 18) && (programme.package_state_id == 4 || (Object.values(programme.availability).some(function (num) { return num <= 0; })))) ? _c('a', {
      staticClass: "cta-button blue",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_click_to_subscribe)
      }
    }) : (programme.package_state_id == 3) ? _c('a', {
      staticClass: "cta-button blue",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_call_to_book)
      }
    }) : _vm._e()]) : _c('div', {
      staticClass: "full-width-cta"
    }, [(programme.package_state_id == 2 && ((programme.prog_id != 1 && programme.prog_id != 17 && programme.prog_id != 18) || ((programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18) && programme.isAvailable))) ? _c('a', {
      staticClass: "cta-button red",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_on_sale)
      },
      on: {
        "click": function($event) {
          _vm.progress(this, programme)
        }
      }
    }) : (programme.package_state_id == 4 || (!programme.isAvailable && (programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18))) ? _c('a', {
      staticClass: "cta-button blue",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_click_to_subscribe)
      }
    }) : (programme.package_state_id == 3) ? _c('a', {
      staticClass: "cta-button blue",
      domProps: {
        "innerHTML": _vm._s(_vm.locale.button_call_to_book)
      }
    }) : _vm._e()])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.programmes.length == 0),
      expression: "programmes.length == 0"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('div', {
    staticClass: "title-block",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_empty)
    }
  })])])], 2) : (_vm.programmes != null && _vm.isQuickAdd) ? _c('div', [(_vm.programmes.length > 0) ? _c('div', {
    staticClass: "fields dropdown"
  }, [_c('label', {
    attrs: {
      "for": "bases_available"
    }
  }, [_vm._v("Programme"), (!_vm.quickSelection.base) ? _c('small', [_vm._v(" - Please select a programme")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-inner"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quickSelection.base),
      expression: "quickSelection.base"
    }],
    attrs: {
      "name": "bases_available",
      "id": "bases_available\n                "
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quickSelection.base = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.programmes), function(programme) {
    return _c('option', {
      attrs: {
        "disabled": programme.package_state_id != 2
      },
      domProps: {
        "value": programme,
        "innerHTML": _vm._s(programme.name + (programme.package_state_id != 2 ? ' - ' + programme.package_state_readable : '') + ' (For ages: ' + programme.min_age + ' to ' + programme.max_age + ')')
      }
    })
  })), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [(_vm.loading) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })]) : (!_vm.loading && _vm.age <= 4) ? _c('div', {
    staticClass: "title-block",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_empty_4_years)
    }
  }) : _c('div', {
    staticClass: "title-block",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_empty)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3245f6b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/BasePackages.vue
// module id = 166
// module chunks = 0